<template>
  <div
    class="profile-nav section-border--top section-border--right section-border--bottom"
    :class="{ mobile: isMobile }"
  >
    <ul>
      <li v-for="(item, index) in profileMenu.submenu" :key="index">
        <nuxt-link :to="item.link">
          {{ item.title }}
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { profileMenu } from "../../config";
export default {
  name: "ProfileNav",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      profileMenu,
    };
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.profile-nav {
  padding: 2rem 0;
  &.mobile {
    border: none;
    overflow-x: auto;
    ul {
      display: flex;
    }
    li {
      white-space: nowrap;
      margin-right: 1rem;
    }
    a {
      padding-bottom: 1rem;
      &.nuxt-link-active {
        border-left: none;
        border-bottom: 2px solid $text;
        padding-left: 0;
      }
    }
  }

  li {
    line-height: 1.4rem;
    margin-bottom: 0.8rem;
    &:last-of-type {
      margin-bottom: 0;
    }
  }

  a {
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: $red;
    text-decoration: none;

    &.nuxt-link-active {
      font-weight: 700;
      color: $text;
      border-left: 2px solid $text;
      padding-left: 1rem;
      display: block;
    }
  }
}
</style>
